
<div class="header space-v-xl">
  <h2 class="header-title">{{ 'APPLICATIONS.LIST.TITLE' | translate }}</h2>
  <div class="header-button">
    <a class="btn-next" [appAuth]="['CLIENT.UPDATE']" mat-raised-button href="/clients/new"><span class="fa fa-plus-circle"></span> {{ 'APPLICATIONS.CREATE_APPLICATION' | translate }}</a>
  </div>
</div>
<div class="header-space-adapter space-v-xl"></div>
<div class="header-space-adapter space-v-xl"></div>
<form>
  <mat-form-field class="search-bar">
    <input matInput [(ngModel)]="searchTxt" (ngModelChange)="search()" [ngModelOptions]="{standalone: true}">
    <button matSuffix mat-raised-button class="btn-normal"><span class="fa fa-search"></span> {{ 'APPLICATIONS.SEARCH' | translate }} </button>
  </mat-form-field>
</form>
<mat-tab-group dynamicHeight class="client-tabs">
  <mat-tab label="{{ 'APPLICATIONS.LIST.ALL' | translate }}">
    <mat-card class="client-card {{haveAccess(['CLIENT.UPDATE']) ? 'cursor' : ''}}" *ngFor="let client of clientList"
              (click)="goToClient('/clients/edit/' + client.functionalId, ['CLIENT.UPDATE'])">
      <mat-card-title class="client-card-title">
        <div class="client-card-title-txt">{{ client.name }}</div>
        <span class="badge badge-primary" *ngIf="client.currentVersion">{{client.currentVersion}}</span>
      </mat-card-title>
      <mat-card-content class="client-card-content">
        <div>
          {{ 'APPLICATIONS.LIST.LATEST_VERSION' | translate }} : {{ client.latestVersion }}
        </div>
        <div>
          ApiKey : {{ client.apikey }}
          <div (click)="$event.stopPropagation()" style="width: 45px;">
            <button class="cursor" role="button" (cdkCopyToClipboardCopied)="notify($event)" [cdkCopyToClipboard]="client.apikey || ''" matTooltip="{{ 'APPLICATIONS.LIST.COPY_BTN_TOOLTIP' | translate }}">
              <i class="fa fa-copy"></i>
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-tab>
  <ng-container *ngFor="let nature of allNatures">
    <mat-tab [label]="nature.label" >
      <ng-container *ngFor="let client of clientList" >
        <mat-card class="client-card {{haveAccess(['CLIENT.UPDATE']) ? 'cursor' : ''}}" *ngIf="nature.key === client.nature"
                  (click)="goToClient('/clients/edit/' + client.functionalId, ['CLIENT.UPDATE'])">
          <mat-card-title class="client-card-title">
            <div class="client-card-title-txt">{{ client.name }}</div>
            <span class="badge badge-primary" *ngIf="client.currentVersion">{{client.currentVersion}}</span>
          </mat-card-title>
          <mat-card-content class="client-card-content">
            <div>
              {{ 'APPLICATIONS.LIST.LATEST_VERSION' | translate }} : {{ client.latestVersion }}
            </div>
            <div>
              ApiKey : {{ client.apikey }}
              <div (click)="$event.stopPropagation()" style="width: 45px;">
                <button class="cursor" role="button" (cdkCopyToClipboardCopied)="notify($event)" [cdkCopyToClipboard]="client.apikey || ''" matTooltip="{{ 'APPLICATIONS.LIST.COPY_BTN_TOOLTIP' | translate }}">
                  <i class="fa fa-copy"></i>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </mat-tab>
  </ng-container>
</mat-tab-group>
